import '@/logger/sentry/setup' // keep near the top
import './index.css'
import 'react-photo-view/dist/react-photo-view.css'

import * as React from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './app'

const root = document.getElementById('root')
if (!root) throw new Error('No root element found')

createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
